<div class="navbar">
  <a *ngFor="let route of routes" [class.active]="isActiveRoute(route.url)" [routerLink]="[route.url]">
    <i class="material-icons">{{route.icon}}</i>
  </a>
</div>